export default "__VITE_ASSET__Blo$O9C7__"